<template>
    <div v-show="!props.hide">
        <sp-form
            class="mobile-general-form-picker flex-picker"
            :class="[`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''}`, `${notChanged ? 'disable-opacity' : ''}`,
                     noPaddingBottom ? 'no-padding-bottom' : '']"
            ref="elForm"
            v-show="!props.hide"
            :model="formModel"
            :rules="rules"
        >
            <sp-form-item prop="pickerValue">
                <div v-if="!globalModel.preview" @click="onClickForm">
                    <sharp-comp-select
                        :label="i18nLabel"
                        :is-required="props.required"
                        :selected-options-text="selectedOptionsText"
                        @click="onClick"
                        :placeholder="formattedPlaceholder"
                        :disabled="notChanged"
                    >
                    </sharp-comp-select>
                </div>
                <!-- 预览时的效果 -->
                <PreviewText
                    v-else
                    :labelText="i18nLabel"
                    :textDesc="selectedOptionsText"
                ></PreviewText>
            </sp-form-item>
            <div
                v-if="props.exampleSettings && !globalModel.preview && !globalModel.hideSubmitStyle"
                class="example-btn"
                @click="onCheckExample"
            >
            </div>

            <picker-panel v-model="panelShow" title="示例图">
                <file-example @confirm="onCheckExample" :exampleData="props.exampleSettings"></file-example>
            </picker-panel>
            <picker-panel
                v-model="fullScreenPanelShow"
                :title="bankPickerTitle"
                :showBack="!inYoda"
                @back-click="onPanelBack"
                :customStyle="{
                    height: '100%',
                    maxHeight: '100%',
                    borderRadius: '0 0 0 0',
                    paddingTop: marginTop,
                    boxSizing: 'border-box',
                    backgroundColor: 'var(--bg-dialog, #fff)',
                }"
            >
                <BankList @selected="onItemSelected" :bankParams="bankParams" :selectedValue="formModel.pickerValue"></BankList>
            </picker-panel>
        </sp-form>
        <!-- 鸿蒙不展示 -->
        <div
            v-show="showBankPhone && bankPhone && !isHarmony"
            class="bank-num plr19"
        >
            详细信息可以咨询银行电话
            <a :href="`tel:${bankPhone}`">
                {{ bankPhone }}
            </a>
        </div>
        <sub-title
            class="plr19 error-right"
            v-show="lastShowRejectTip(i18nLabel)"
            :errorMsg="outputError(i18nLabel)"
        ></sub-title>
    </div>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { component } from './props';
import { isPickerSupport, showPicker } from './picker';
import PreviewText from '../component-base/common/preview-text';
import FileExample from '../component-base/common/file-example';
import PickerPanel from '../component-base/common/picker-panel';
import BankList from './bank-list.vue';
import { getToolProvince, getToolCity } from './service';
import { inYoda, inIm, isHarmony } from '../../utils/bridge';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { RESULT_FALLBACK_VALUE } from '../../const';
import SubTitle from '../component-base/common/sub-title';
import { useBridge } from '../../utils/bridge/common';
const mapBankPhone = 'Map__BankPhone';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SharpCompSelect,
        PreviewText,
        FileExample,
        PickerPanel,
        BankList,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                pickerValue: [],
            },
            isPickerSupport: false,
            panelShow: false,
            fullScreenPanelShow: false,
            bankParams: {},
            provinceList: [],
            marginTop: inIm ? '22px' : '0',
            cityList: [],
            inYoda: inYoda,
            bankPickerTitle: '选择银行名称',
            bankPhone: '', // 当前银行电话号
            showBankPhone: false, // 展示银行电话号
            isHarmony: isHarmony,
        };
    },
    watch: {
        selectedOptionsText: {
            handler(newVal) {
                if (newVal) {
                    const bankPhone = this.getFormDataValueByPath(`${mapBankPhone}.${this.selectedOptionsText}.${this.outputPath}`);
                    if (bankPhone && newVal !== '没有我想选择的内容') {
                        this.bankPhone = bankPhone;
                    }
                }
            },
            immediate: true,
        },
    },
    async created() {
        if (inIm) {
            const nameSpaceApi = 'webview.getDeviceInfo';
            const params = {};
            const res = await useBridge(nameSpaceApi, params);
            this.setToolbarStyle(res.data);
        }
        if (this.props && this.props.pickerSettings) {
            const { showBankPhone = '2', type } = this.props.pickerSettings;
            if (type === 'bank') {
                this.showBankPhone = showBankPhone === '1' ? true : false;
            }
        }
    },
    async mounted() {
        // 检测一次就够了
        this.checkKsBridge();
        if (this.props.pickerSettings && this.props.pickerSettings.type === 'province') {
            // this.provinceList = await getToolProvince();
            const list = await getToolProvince() || [];
            this.provinceList = list.map(item => {
                return {
                    text: item.name,
                    value: {
                        cityCode: '',
                        cityName: '',
                        code: item.code,
                        provinceName: item.name,
                    },
                };
            });
        }
        if (this.props.pickerSettings && this.props.pickerSettings.type === 'city') {
            const { type, provinceDataSource } = this.props.pickerSettings;
            formEventBus.$on(FORM_EVENTS_TYPE.PICKER_VALUE_CHANGE, async (uuid, pickerValue) => {
                if (provinceDataSource !== uuid) {return;}
                this.onPick([]);
                const list = await getToolCity({
                    provinceId: pickerValue[0].value.code,
                    provinceCode: pickerValue[0].value.code,
                }) || [];
                this.cityList = list.map(item => {
                    const { code, name } = item;
                    return {
                        text: name,
                        value: {
                            cityCode: code,
                            cityName: name,
                            code: pickerValue[0].value.code,
                            provinceName: pickerValue[0].value.provinceName,
                        },
                    };
                });
            });
        }
        if (this.props.pickerSettings && this.props.pickerSettings.type === 'branch') {
            const { type, cityDataSource, bankDataSource, provinceDataSource } = this.props.pickerSettings;
            formEventBus.$on(FORM_EVENTS_TYPE.PICKER_VALUE_CHANGE, async (uuid, pickerValue) => {
                if (![cityDataSource, bankDataSource, provinceDataSource].includes(uuid)) {return;}
                this.onPick([]);
            });
        }
        this.sendShowClick('SHOW');
    },
    computed: {
        rules() {
            return {
                pickerValue: this.composeRules(this.props),
            };
        },
        i18nOptions() {
            // 遍历options中的所有text字段，全部过一遍i18n方法
            if (Array.isArray(this.props.options)) {
                return this.props.options.map(columnArray => {
                    if (Array.isArray(columnArray)) {
                        return columnArray.map(option => {
                            return {
                                ...option,
                                text: this.i18n(option.text),
                            };
                        }, this);
                    }
                    // 理论上走到这里的配置是不合法的，不过避免报错还是写个返回值吧
                    return [];
                }, this);
            }
            return [];
        },
        selectedOptionsText() {
            if (this.formModel.pickerValue.length && this.formModel.pickerValue[0].text === RESULT_FALLBACK_VALUE) {
                return '没有我想选择的内容';
            }
            return this.formModel.pickerValue
                .map(item => item.text)
                .join(' / ');
        },
        formattedPlaceholder() {
            return this.i18n(this.props.placeholder).replace('$', '') || '';
        },
        sendLogName() {
            if (this.globalModel.preview || this.props.hide) {return '';}
            if (!this.props.pickerSettings || !this.props.pickerSettings.type) {return '';}
            const type = this.props.pickerSettings.type;
            let eleName = 'AREA_SELECTOR_ITEM';
            if (type === 'branch' || type === 'bank') {
                eleName = 'SELECTOR_ITEM';
            }
            return eleName;
        },
        noPaddingBottom() {
            // 如果是驳回，并且有错误提示 padding-bottom 为0
            if (this.lastShowRejectTip(this.i18nLabel) && this.outputError(this.i18nLabel)) {
                return true;
            }
            // 如果是银行，并且有银行电话，padding-bottom 为0
            if (this.props && this.props.pickerSettings) {
                const { type = '' } = this.props.pickerSettings || {};
                if (type === 'bank') {
                    return this.showBankPhone && this.bankPhone && !this.isHarmony;
                }
                return false;
            }
            return false;
        },
    },
    methods: {
        onPickerClear() {
            this.onPick([]);
        },
        sendShowClick(action) {
            const eleName = this.sendLogName;
            if (!eleName) {return;}
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, action, eleName, {
                item_title: this.i18nLabel,
                is_connect_ocr: this.props.ocrConfig && this.props.ocrConfig.ocrKey ? 1 : 0,
            });
        },
        setToolbarStyle(data) {
            if (data && data.titleBarHeight && data.statusBarHeight) {
                let r;
                if (data.devicePixelRatio) {
                    r = data.devicePixelRatio;
                } else {
                    r = window.devicePixelRatio || 2;
                }
                const statusHeight = `${data.statusBarHeight / r}px`;
                this.marginTop = statusHeight;
            }
        },
        onPanelBack() {
            this.fullScreenPanelShow = false;
        },
        onItemSelected(item) {
            this.fullScreenPanelShow = false;
            this.onPick([{
                text: item.label,
                value: item.value,
            }]);
            this.bankPhone = item.phone || '';
            this.bankPhone && this.setFormDataValueByPath(this.bankPhone || '', `${mapBankPhone}.${item.label}.${this.outputPath}`);
        },
        onCheckExample() {
            this.panelShow = !this.panelShow;
        },
        checkKsBridge() {
            this.isPickerSupport = isPickerSupport();
            if (!this.isPickerSupport) {
                this.$nextTick(() => {
                    this.$emit('no-ks-bridge');
                });
            }
        },
        checkNoCityData(cityData) {
            if (!cityData || !cityData.length) {
                return true;
            }
            return Object.keys(cityData[0]).length === 0;
        },
        onSelectBank() {
            const { type, cityDataSource, bankDataSource, provinceDataSource } = this.props.pickerSettings;
            if (type === 'bank' ) {
                this.bankPickerTitle = '选择银行名称';
                this.bankParams = {
                    type,
                    bankPickerTitle: this.bankPickerTitle,
                };
            } else {
                this.bankPickerTitle = '选择支行名称';
                const bankData = this.getValueById(bankDataSource, 'value');
                // 校验空值
                if (!bankData || !bankData.length) {
                    this.$toast.error('请选择银行名称！');
                    return;
                }
                const cityData = this.getValueById(cityDataSource, 'value');
                if (this.checkNoCityData(cityData)) {
                    this.$toast.error('请选择开户行城市！');
                    return;
                }
                const provinceData = this.getValueById(provinceDataSource, 'value');
                if (!provinceData || !provinceData.length) {
                    this.$toast.error('请选择开户行省份！');
                    return;
                }
                this.bankParams = {
                    type,
                    bankData: bankData[0],
                    cityData: cityData[0].value,
                    bankPickerTitle: this.bankPickerTitle,
                };
            }
            this.fullScreenPanelShow = true;
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'SELECTOR_POPUP', {
                title: this.bankPickerTitle,
            });
        },
        async onSelectCity(param) {
            const { type, provinceDataSource } = this.props.pickerSettings;
            let options;
            if (type === 'province') {
                options = this.provinceList;
            } else if (type === 'city') {
                if (this.cityList.length) {
                    options = this.cityList;
                } else {
                    const provinceData = this.getValueById(provinceDataSource, 'value');
                    // 校验空值
                    if (!provinceData || !provinceData.length) {
                        this.$toast.error('请先选择省份名称！');
                        return;
                    }
                    const list = await getToolCity({
                        // provinceId: provinceData[0].value.code,
                        provinceCode: provinceData[0].value.code,
                    }) || [];
                    options = list.map(item => {
                        const { code, name } = item;
                        return {
                            text: name,
                            value: {
                                cityCode: code,
                                cityName: name,
                                code: provinceData[0].value.code,
                                provinceName: provinceData[0].value.provinceName,
                            },
                        };
                    });
                }
            }
            try {
                const ret = await showPicker({
                    ...param,
                    data: [options],
                });
                this.onPick(ret);
            } catch (e) {
                // do nothing
            }
        },
        async onClick() {
            const param = {
                headerText: this.i18n(this.props.headerText) || this.i18nLabel,
                cancelText: this.i18n(this.props.cancelText),
                okText: this.i18n(this.props.okText),
                default: this.formModel.pickerValue,
                group: !!this.props.group,
                column: +this.props.column,
                data: this.i18nOptions,
            };
            if (!this.props.pickerSettings || !this.props.pickerSettings.type) {
                try {
                    const ret = await showPicker(param);
                    this.onPick(ret);
                } catch (e) {
                    //
                }
                return;
            }
            this.sendShowClick('CLICK');
            const { type, cityDataSource, bankDataSource, proviceDataSource } = this.props.pickerSettings;
            if (type === 'bank' || type === 'branch') {
                this.onSelectBank();
            } else if (type === 'city' || type === 'province') {
                this.onSelectCity(param);
            }
        },
        onPick($event) {
            const isChanged = JSON.stringify($event) !== JSON.stringify(this.formModel.pickerValue);
            this.formModel.pickerValue = $event;
            this.onPickerValueChange($event);
            this.$emit('user-input');
            if (this.props.pickerSettings && isChanged) {
                formEventBus.$emit(FORM_EVENTS_TYPE.PICKER_VALUE_CHANGE, this.config.uuid, this.formModel.pickerValue);
            }
        },
        onPickerValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.pickerValue);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (!Array.isArray(newValue)) {
                // 默认值逻辑
                if (this.formModel.pickerValue.length) {
                    this.formModel.pickerValue = [];
                }
                this.onPickerValueChange();
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.pickerValue, newValue)) {
                this.formModel.pickerValue = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.pickerValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.flex-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    /deep/ .sp-form-item {
        flex: 1;
    }
    /deep/ .clear-btn {
        position: absolute;
        top: 0;
        right: 20px;
    }
}
.no-padding-bottom {
    /deep/ .sp-form-item {
        padding-bottom: 0!important;
    }
}
.bank-num {
    text-align: right;
    font-size: 13px;
    line-height: 16px;
    color: #666666;
    margin-top: 4px;
}
.mt20 {
    margin-top: -4px;
}
.full-container {
    .radio-list {
        .radio-item{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 16px 19px;
            color: var(--font-common,#222);
            font-size: 16px;
            line-height: 22px;
            border-bottom: 1px solid #f5f5f5;
            .radio-icon {
                width: 20px;
                height: 20px;
                background-size: 100% 100%;
            }
            .radio-checked {
                background-image: url('../../../assets/images/checked.svg');
            }
            .radio-unchecked {
                background-image: url('../../../assets/images/unchecked.svg');
            }
        }
    }
}
</style>
